import organizationApi from '../../../api/pipedrive/organization'

// state
const state = () => ({
    persons: [],
})

// getters
const getters = {

    getPersons(state) {
        return state.persons.data
    },

}

// actions
const actions = {
    async getPersons({commit}, organization_id) {
        var response = await organizationApi.GetAssociatedPersons(organization_id);
        commit('setPersons', response.data.data)
    },

}

// mutators
const mutations = {

  setPersons(state, persons) {
        state.persons = {
          ...persons,
          data: (persons?.data ?? []).map(person => ({
            id: person.id,
            value: person.value,
            name: person.name,
            first_name: person.first_name,
            last_name: person.last_name,
            email: person.email ?? person.emails ?? [],
            phone: person.phone ?? person.phones ?? [],
            org_id: person.org_id,
            company_id: person.company_id,
            marketing_status: person.marketing_status,
          })),
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
